import styled from 'styled-components';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { Button } from 'shared/components/Button';
import { Input } from 'shared/components/Input';
import { t } from 'localization/utils/t';

const TP = 'paymentVerifications.components.VerificationCodeForm';

export interface IVerificationCodeForm {
  className?: string;
  isLoading?: boolean;
  onSubmit: (code: string) => void;
}

export default function VerificationCodeForm({
  className,
  isLoading = false,
  onSubmit,
}: IVerificationCodeForm) {
  const handleOnSubmit = (values, setSubmitting) => {
    const { code } = values;
    onSubmit(code);
    setSubmitting(false);
  };

  const validationSchema = Yup.object().shape({
    code: Yup.string()
      .required(t(`${TP}.codeRequired`, 'Please, enter a code'))
      .min(5, t(`${TP}.codeMin`, 'Please, enter 5-6 characters'))
      .max(6, t(`${TP}.codeMax`, 'Please, enter 5-6 characters')),
  });

  return (
    <Formik
      initialValues={{ code: '' }}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting }) => handleOnSubmit(values, setSubmitting)}
    >
      {({ values, touched, errors, handleSubmit, handleChange, handleBlur, isSubmitting }) => (
        <form className={className} onSubmit={handleSubmit}>
          <VerificationCodeForm.Input disabled={isLoading || isSubmitting}>
            <Input
              data-qa="verification_code_form_input"
              label={t(`${TP}.confirmationCode`, '5-6 Digit Confirmation Code')}
              id="code"
              name="code"
              value={values.code}
              hasError={!!(touched.code && errors.code)}
              errorMessage={errors.code}
              onChange={handleChange}
              onBlur={handleBlur}
              type="code"
              hasFloatingLabel
            />
          </VerificationCodeForm.Input>

          <VerificationCodeForm.Submit
            data-qa="verification_code_form_button"
            type="submit"
            disabled={values.code.length < 5 || values.code.length > 6 || isLoading || isSubmitting}
            loading={isLoading || isSubmitting}
            inverted
          >
            {t(`${TP}.submit`, 'Submit')}
          </VerificationCodeForm.Submit>
        </form>
      )}
    </Formik>
  );
}

VerificationCodeForm.Input = styled.div<{ disabled: boolean }>`
  ${({ disabled }) => disabled && 'pointer-events: none;'}
`;
VerificationCodeForm.Submit = styled(Button)`
  width: 100%;
  max-width: 180px;
  margin: 0 auto;
`;
